import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { colors } from "./colors/color";
import { CardShadow } from "./shadow";
import { amorgStyles } from './styles/amorgStyles';
import { CardVariantStyles } from './styles/cardStyles';

export const CardVariants = ['outlined', 'light', 'lightGray', 'attention', 'none', 'darkBlue'] as const;
export type CardVariant = typeof CardVariants[number];

type CardProps = {
    variant?: CardVariant,
    marginTop?:number,
    marginBottom?:number,
    padding?: string,
    flex?:boolean,
    flexGrow?:string,
    style?: React.CSSProperties,
    disabled?:boolean,
    shadow?:boolean,
    noBorder?:boolean
}

export function Card(props:PropsWithChildren<CardProps>):JSX.Element
{
    const cardStyles = amorgStyles(colors).card;
    let variant = props.variant ?? 'light';
    if(!CardVariants.includes(variant))
        variant = 'light';
    const variantStyle:CardVariantStyles = cardStyles.variants[variant];

    return <BaseCard variantStyle={variantStyle} {...props}>{props.children}</BaseCard>;
}

const BaseCard = styled.div<{variantStyle:CardVariantStyles, marginTop?:number, marginBottom?:number, padding?: string, flex?:boolean, flexGrow?:string, shadow?:boolean, noBorder?:boolean }>`
    margin-top:${props => props.marginTop===undefined ? '0px' : `${props.marginTop}px`};
    margin-bottom:${props => props.marginBottom===undefined ? '0px' : `${props.marginBottom}px`};
    padding:${props => props.padding ? props.padding : '1rem'};
    ${props => props.flex && "display: flex;" }
    ${props => props.flexGrow && `flex-grow: ${props.flexGrow};` }
    ${props => props.shadow && `box-shadow: ${CardShadow};` }
    transition: all 0.2s ease-in;

    border-radius: ${props => amorgStyles(props.theme.colors).card.borderRadius};

    background-color: ${props => props.variantStyle.default.background};
    border: ${props => props.variantStyle.default.border};
    ${props => props.noBorder && `border: none;` }
    color: ${props => props.variantStyle.default.color};
`;